module.exports = "/images/chemical-hazard@3x.png?4084682b4223f08ea88e735f539f9a74";